import * as ACTION from 'actions';

const initState = {
    is_login: false,
    session: null
};

export const login = (state=initState, action) => {
    switch (action.type) {
        case ACTION.USER_LOGIN:
            return action.user;
        case ACTION.USER_LOGOUT:
            return initState;
        default:
            return state;

    }
};